import {Navigator} from "three/src/renderers/webxr/WebXR";
import {WebGLRenderer, XRSession, XRSessionInit} from "three";

const DISABLED = true;
export const xr = (window.navigator as Navigator).xr;
export let hasXR = false;
export let xrSession:XRSession|undefined;

xr?.isSessionSupported('immersive-ar').then(result=>{
    hasXR = result;
})

export const xrEnabled = ():boolean => {
    return !DISABLED && hasXR && !!xr
}

export const startXR = (renderer:WebGLRenderer, overlay=document.getElementById("xr-overlay"))=>{
    const sessionInit:_XRSessionInit = {
        optionalFeatures:['dom-overlay'],
        domOverlay:{root:overlay as HTMLDivElement}
    };

    return xr!.requestSession( 'immersive-ar', sessionInit).then((session)=>{
        xrSessionStarted(session, renderer);
    });
}

export const stopXR = ()=>{
    xrSession?.end();
}

const xrSessionEnded=()=>{
    console.log(`XR session ended`);
    const overlay = document.getElementById("xr-overlay") as HTMLDivElement;
    overlay.style.display = 'none';
    xrSession = undefined;
};

const xrSessionStarted=(session:XRSession, renderer:WebGLRenderer)=>{

    console.log(`Got xr session`);
    session.addEventListener( 'end', xrSessionEnded );

    const overlay = document.getElementById("xr-overlay") as HTMLDivElement;
    overlay.style.display = '';

    renderer.xr.setReferenceSpaceType( 'local' );

    renderer.xr.setSession(session).then(()=>{
        console.log("xr set session callback");
    });

    xrSession = session;
};

/**
 * FROM THREE.js extensions to allow overlays, but not in old data. works.
 *
 * BEGIN: WebXR DOM Overlays Module
 * https://immersive-web.github.io/dom-overlays/
 */

interface XRDOMOverlayInit {
    root: Element;
}

export interface _XRSessionInit extends XRSessionInit {
    domOverlay?: XRDOMOverlayInit | undefined;
}

type XRDOMOverlayType = 'screen' | 'floating' | 'head-locked';

interface XRDOMOverlayState {
    type: XRDOMOverlayType;
}

interface _XRSession extends XRSession {
    readonly domOverlayState?: XRDOMOverlayState | undefined;
}

/**
 * END: WebXR DOM Overlays Module
 * https://immersive-web.github.io/dom-overlays/
 */
